export const cityReducer = (state = [], action) => {
  switch (action.type) {
    case "CITY_PRODUCT_COUNT":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
